import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const withdrawPettyCashCheque = createAsyncThunk(
	"withdrawPettyCashCheque",
	async ({ chequeId, withdrawDate }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.put(`petty-cash/cheque/${chequeId}/withdraw`, {
				withdrawDate,
			});
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	},
);

const PettyCashChequeWithdrawSlice = createSlice({
	name: "PettyCashChequeWithdrawSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPettyCashChequeWithdrawState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(withdrawPettyCashCheque.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
			state.error = null;
		});
		builder.addCase(withdrawPettyCashCheque.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(withdrawPettyCashCheque.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashChequeWithdrawState } = PettyCashChequeWithdrawSlice.actions;
export default PettyCashChequeWithdrawSlice.reducer;
